// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionPlanRequestDetailModal_backdrop__4M6FL {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 28px;
    background: rgba(11, 31, 44, .52);
    -webkit-backdrop-filter: blur(3px);
            backdrop-filter: blur(3px)
}

.ActionPlanRequestDetailModal_modal__hnaGk {
    position: relative;
    width: min(700px, 96vw);
    max-height: 90vh;
    overflow: auto;
    padding: 34px;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 28px 90px rgba(12, 36, 51, .32);
    color: #1d2a32
}

.ActionPlanRequestDetailModal_closeButton__kre7V {
    position: absolute;
    top: 16px;
    right: 18px;
    width: 38px;
    height: 38px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: #48606f;
    font-size: 1.9rem;
    line-height: 1;
    cursor: pointer
}

.ActionPlanRequestDetailModal_closeButton__kre7V:hover {
    background: #eef3f6
}

.ActionPlanRequestDetailModal_badges__ter5R {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 0 44px 16px 0
}

.ActionPlanRequestDetailModal_typeBadge__nBMxh,
.ActionPlanRequestDetailModal_valueBadge__YH-HG {
    padding: 6px 11px;
    border-radius: 8px;
    font-size: .8rem;
    font-weight: 600
}

.ActionPlanRequestDetailModal_typeBadge__nBMxh {
    background: #edf3f6;
    color: #31556a
}

.ActionPlanRequestDetailModal_valueBadge__YH-HG {
    background: #ffe69a;
    color: #9a6410
}

.ActionPlanRequestDetailModal_modal__hnaGk h2 {
    margin: 0;
    font-size: 2rem;
    line-height: 1.14
}

.ActionPlanRequestDetailModal_summaryList__Pd162 {
    display: grid;
    gap: 9px;
    margin: 26px 0
}

.ActionPlanRequestDetailModal_summaryList__Pd162 div {
    display: grid;
    grid-template-columns: 150px 1fr;
    gap: 14px;
    align-items: baseline
}

.ActionPlanRequestDetailModal_summaryList__Pd162 dt {
    color: #6d7b84;
    font-size: .86rem
}

.ActionPlanRequestDetailModal_summaryList__Pd162 dd {
    margin: 0;
    font-weight: 600
}

.ActionPlanRequestDetailModal_detailSection__RTKMa {
    margin-top: 26px
}

.ActionPlanRequestDetailModal_detailSection__RTKMa h3 {
    margin: 0 0 10px;
    font-size: 1.25rem
}

.ActionPlanRequestDetailModal_detailSection__RTKMa p {
    margin: 0;
    line-height: 1.55;
    white-space: pre-line
}

.ActionPlanRequestDetailModal_emptyDetail__nBHXD {
    color: #71808a;
    font-style: italic
}

.ActionPlanRequestDetailModal_closeAction__tSj3r {
    min-width: 150px;
    min-height: 44px;
    margin-top: 30px;
    padding: 10px 16px;
    border: 1px solid #9eb4c1;
    border-radius: 8px;
    background: #fff;
    color: #31556a;
    font-weight: 700;
    cursor: pointer
}

.ActionPlanRequestDetailModal_closeAction__tSj3r:hover {
    background: #eef5f8
}

@media(max-width:520px) {
    .ActionPlanRequestDetailModal_backdrop__4M6FL {
        align-items: flex-end;
        padding: 0
    }

    .ActionPlanRequestDetailModal_modal__hnaGk {
        width: 100%;
        max-height: 94vh;
        padding: 28px 22px;
        border-radius: 18px 18px 0 0
    }

    .ActionPlanRequestDetailModal_modal__hnaGk h2 {
        font-size: 1.65rem
    }

    .ActionPlanRequestDetailModal_summaryList__Pd162 div {
        grid-template-columns: 1fr;
        gap: 2px
    }

    .ActionPlanRequestDetailModal_closeButton__kre7V {
        top: 10px;
        right: 10px
    }

    .ActionPlanRequestDetailModal_closeAction__tSj3r {
        width: 100%
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ActionPlan/ActionPlanRequestDetailModal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,iCAAiC;IACjC,kCAAyB;YAAzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,SAAS;IACT,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR;AACJ;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;AACJ","sourcesContent":[".backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 2000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 28px;\n    background: rgba(11, 31, 44, .52);\n    backdrop-filter: blur(3px)\n}\n\n.modal {\n    position: relative;\n    width: min(700px, 96vw);\n    max-height: 90vh;\n    overflow: auto;\n    padding: 34px;\n    border-radius: 18px;\n    background: #fff;\n    box-shadow: 0 28px 90px rgba(12, 36, 51, .32);\n    color: #1d2a32\n}\n\n.closeButton {\n    position: absolute;\n    top: 16px;\n    right: 18px;\n    width: 38px;\n    height: 38px;\n    border: 0;\n    border-radius: 50%;\n    background: transparent;\n    color: #48606f;\n    font-size: 1.9rem;\n    line-height: 1;\n    cursor: pointer\n}\n\n.closeButton:hover {\n    background: #eef3f6\n}\n\n.badges {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin: 0 44px 16px 0\n}\n\n.typeBadge,\n.valueBadge {\n    padding: 6px 11px;\n    border-radius: 8px;\n    font-size: .8rem;\n    font-weight: 600\n}\n\n.typeBadge {\n    background: #edf3f6;\n    color: #31556a\n}\n\n.valueBadge {\n    background: #ffe69a;\n    color: #9a6410\n}\n\n.modal h2 {\n    margin: 0;\n    font-size: 2rem;\n    line-height: 1.14\n}\n\n.summaryList {\n    display: grid;\n    gap: 9px;\n    margin: 26px 0\n}\n\n.summaryList div {\n    display: grid;\n    grid-template-columns: 150px 1fr;\n    gap: 14px;\n    align-items: baseline\n}\n\n.summaryList dt {\n    color: #6d7b84;\n    font-size: .86rem\n}\n\n.summaryList dd {\n    margin: 0;\n    font-weight: 600\n}\n\n.detailSection {\n    margin-top: 26px\n}\n\n.detailSection h3 {\n    margin: 0 0 10px;\n    font-size: 1.25rem\n}\n\n.detailSection p {\n    margin: 0;\n    line-height: 1.55;\n    white-space: pre-line\n}\n\n.emptyDetail {\n    color: #71808a;\n    font-style: italic\n}\n\n.closeAction {\n    min-width: 150px;\n    min-height: 44px;\n    margin-top: 30px;\n    padding: 10px 16px;\n    border: 1px solid #9eb4c1;\n    border-radius: 8px;\n    background: #fff;\n    color: #31556a;\n    font-weight: 700;\n    cursor: pointer\n}\n\n.closeAction:hover {\n    background: #eef5f8\n}\n\n@media(max-width:520px) {\n    .backdrop {\n        align-items: flex-end;\n        padding: 0\n    }\n\n    .modal {\n        width: 100%;\n        max-height: 94vh;\n        padding: 28px 22px;\n        border-radius: 18px 18px 0 0\n    }\n\n    .modal h2 {\n        font-size: 1.65rem\n    }\n\n    .summaryList div {\n        grid-template-columns: 1fr;\n        gap: 2px\n    }\n\n    .closeButton {\n        top: 10px;\n        right: 10px\n    }\n\n    .closeAction {\n        width: 100%\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `ActionPlanRequestDetailModal_backdrop__4M6FL`,
	"modal": `ActionPlanRequestDetailModal_modal__hnaGk`,
	"closeButton": `ActionPlanRequestDetailModal_closeButton__kre7V`,
	"badges": `ActionPlanRequestDetailModal_badges__ter5R`,
	"typeBadge": `ActionPlanRequestDetailModal_typeBadge__nBMxh`,
	"valueBadge": `ActionPlanRequestDetailModal_valueBadge__YH-HG`,
	"summaryList": `ActionPlanRequestDetailModal_summaryList__Pd162`,
	"detailSection": `ActionPlanRequestDetailModal_detailSection__RTKMa`,
	"emptyDetail": `ActionPlanRequestDetailModal_emptyDetail__nBHXD`,
	"closeAction": `ActionPlanRequestDetailModal_closeAction__tSj3r`
};
export default ___CSS_LOADER_EXPORT___;
